import {
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { sortableKeyboardCoordinates } from "@dnd-kit/sortable";

const REORDER_POINTER_ACTIVATION_DISTANCE = 6;

/** Shared drag sensors for sortable lists and table reorder handles. */
export function useReorderSensors() {
  return useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: REORDER_POINTER_ACTIVATION_DISTANCE },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );
}
